const $ = window.jQuery || {};

class StickyHeader {
  constructor() {
    this.header = $("#masthead");
    this.desktopHeader = $("#ast-desktop-header");
    this.mobileHeader = $("#ast-mobile-header");
    this.placeholder = $('<div class="sticky-header-placeholder"></div>');
    this.lastScrollTop = 0;
    this.delta = 5;
    this.isHidden = false;
    this.resizeTimer = null;

    this.init(() => {
      console.log("StickyHeader initialized");
    });
  }

  init() {
    // Wait for Astra to finish rendering the header
    // setTimeout(() => {
    this.insertPlaceholder();
    this.updatePlaceholder();
    this.bindEvents();
    // }, 0);
  }

  insertPlaceholder() {
    this.header.after(this.placeholder);
  }

  updatePlaceholder() {
    const activeHeader = this.getActiveHeader();
    const headerHeight = activeHeader.outerHeight();
    this.placeholder.height(headerHeight);
  }

  getActiveHeader() {
    return this.desktopHeader.is(":visible")
      ? this.desktopHeader
      : this.mobileHeader;
  }

  bindEvents() {
    $(window).on("scroll", this.handleScroll.bind(this));
    $(window).on("resize", this.handleResize.bind(this));
    // Listen for Astra's custom event if available
    $(document).on("astHeaderBreakPoint", this.updatePlaceholder.bind(this));
  }

  handleScroll() {
    const scrollTop = $(window).scrollTop();
    const headerHeight = this.getActiveHeader().outerHeight();

    if (scrollTop > 0) {
      this.header.addClass("ast-sticky-active");
      this.placeholder.addClass("active");
    } else {
      this.header.removeClass("ast-sticky-active");
      this.placeholder.removeClass("active");
    }

    if (Math.abs(this.lastScrollTop - scrollTop) <= this.delta) return;

    if (scrollTop > this.lastScrollTop && scrollTop > headerHeight) {
      // Scrolling down
      if (!this.isHidden) {
        this.header.addClass("hidden");
        this.isHidden = true;
      }
    } else {
      // Scrolling up
      if (this.isHidden) {
        this.header.removeClass("hidden");
        this.isHidden = false;
      }
    }

    this.lastScrollTop = scrollTop;
  }

  handleResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.updatePlaceholder();
    }, 250);
  }
}

export default StickyHeader;
